var React = require('react');

function IconArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("polygon",{"points":"3.5,8 9.5,14 10.5,13 5.5,8 10.5,3 9.5,2 \t\t"}))));
}

IconArrowLeft.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"16px","height":"16px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = IconArrowLeft;

IconArrowLeft.default = IconArrowLeft;
